module.exports = __webpack_public_path__ + "static/media/search-icon.a545db5d.svg";